var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('ul',_vm._l((_vm.navArr),function(i){return _c('li',{key:i.index,class:[i.isActive ? 'nav_text_active' : 'nav_text'],on:{"click":function($event){return _vm.navClick(i)}}},[_vm._v(" "+_vm._s(i.text)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }